import dayjs from "dayjs";
import dayOfYear from "dayjs/plugin/dayOfYear";
import duration from "dayjs/plugin/duration";
import objectSupport from "dayjs/plugin/objectSupport";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekday from "dayjs/plugin/weekday";

dayjs.extend(objectSupport);
dayjs.extend(weekday);
dayjs.extend(dayOfYear);
dayjs.extend(weekOfYear);
dayjs.extend(duration);

export class CronState {
  // public timeSeries: TimeSeriesType = "once";
  // public cronobject: QuartzObject | HumanReadableObject;
  // public diffunit: dayjs.ManipulateType = "day";
  // private _onlyWeeks: boolean = true;
  // private _weekInterval: number = 1;
  // private _cronstringcopied: boolean = false;
  // private _selectedMonthInCalendar: number = dayjs().get("month");
  // private _selectedYearInCalendar: number = dayjs().get("year");
  // private _startdate: Dayjs = dayjs().second(0).minute(0).hour(8);
  // private _currentEnddate: Dayjs | undefined = undefined;
  // private _monthlySwitcher: number = 1;
  // private _currentSchedule: later.Schedule | undefined = undefined;
  // /**
  //  * @name CronState
  //  * @author Nico Vitt
  //  * @description The format referred to is the one by Quarts Scheduler. For further information follow these links.
  //  * http://www.quartz-scheduler.org/documentation/quartz-2.3.0/tutorials/crontrigger.html and
  //  * https://www.freeformatter.com/cron-expression-generator-quartz.html
  //  */
  // constructor(value?: ScheduleDataObjectType) {
  //   makeAutoObservable(this);
  //   // console.log("CronState constructor", value);
  //   if (value !== undefined) {
  //     //Set the cron object
  //     if (value.schedule_type === "cron") {
  //       this.cronobject = new QuartzObject(this.startdate);
  //     }
  //     if (this.cronobject === undefined) {
  //       console.error("CronObject is undefined");
  //       this.cronobject = new HumanReadableObject(this.startdate);
  //       // return;
  //     }
  //     //Set cron string
  //     if (value.schedule_type === "cron") {
  //       this.cronobject.parseCronString(value.cron);
  //     }
  //     //Set startdate
  //     this.startdate =
  //       value.schedule_type === "timestamp" &&
  //       value.timestamp?.startDate !== undefined
  //         ? dayjs(value.timestamp?.startDate)
  //         : dayjs().second(0).minute(0).hour(8);
  //     //Set enddate
  //     this.currentEnddate =
  //       value.schedule_type === "timestamp" &&
  //       value.timestamp?.endDate !== undefined
  //         ? dayjs(value.timestamp?.endDate)
  //         : undefined;
  //   } else {
  //     this.cronobject = new HumanReadableObject(this.startdate);
  //   }
  //   this.updateCurrentSchedule();
  // }
  // public get weekInterval(): number {
  //   return this._weekInterval;
  // }
  // public set weekInterval(v: number) {
  //   this._weekInterval = v;
  //   this.updateCurrentSchedule();
  // }
  // public get cronstringcopied(): boolean {
  //   return this._cronstringcopied;
  // }
  // public set cronstringcopied(v: boolean) {
  //   this._cronstringcopied = v;
  // }
  // public get selectedMonthInCalendar(): number {
  //   return this._selectedMonthInCalendar;
  // }
  // public set selectedMonthInCalendar(v: number) {
  //   this._selectedMonthInCalendar = v;
  //   this.updateCurrentSchedule();
  // }
  // public get selectedYearInCalendar(): number {
  //   return this._selectedYearInCalendar;
  // }
  // public set selectedYearInCalendar(v: number) {
  //   this._selectedYearInCalendar = v;
  //   this.updateCurrentSchedule();
  // }
  // public get startdate(): Dayjs {
  //   return this._startdate;
  // }
  // public set startdate(v: Dayjs) {
  //   this.cronobject.updateStartdate(v);
  //   this._startdate = v;
  //   this.updateCurrentSchedule();
  // }
  // public get currentEnddate(): Dayjs | undefined {
  //   return this._currentEnddate;
  // }
  // public set currentEnddate(v: Dayjs | undefined) {
  //   this._currentEnddate = v;
  //   this.updateCurrentSchedule();
  // }
  // public get monthlySwitcher(): number {
  //   return this._monthlySwitcher;
  // }
  // public set monthlySwitcher(v: number) {
  //   if (this.cronobject.type === "quartz") {
  //     if (v === 1) {
  //       (this.cronobject as QuartzObject).dayofweek = "?";
  //     }
  //     if (v === 2) {
  //       (this.cronobject as QuartzObject).dayofmonth = "?";
  //     }
  //   }
  //   this._monthlySwitcher = v;
  //   this.updateCurrentSchedule();
  // }
  // public get onlyWeeks(): boolean {
  //   return this._onlyWeeks;
  // }
  // public set onlyWeeks(v: boolean) {
  //   if (v) {
  //     if (this.cronobject.type === "quartz") {
  //       //When onlyWeeks is true set this.quartzobject.dayofmonth to the date() of monday in this.startdate
  //       (this.cronobject as QuartzObject).dayofmonth = dayjs(this.startdate)
  //         .weekday(1)
  //         .date()
  //         .toString();
  //     }
  //     if (this.cronobject.type === "human") {
  //       (this.cronobject as HumanReadableObject).DAYS = "1";
  //     }
  //     //When this.timeSeries is TimeSeriesType.daily set this.timeSeries to TimeSeriesType.weekly
  //     if (this.timeSeries === "daily") {
  //       this.timeSeries = "weekly";
  //     }
  //   }
  //   this._onlyWeeks = v;
  //   this.updateCurrentSchedule();
  // }
  // public get currentSchedule(): later.Schedule | undefined {
  //   return this._currentSchedule;
  // }
  // public set currentSchedule(schedule: later.Schedule | undefined) {
  //   this._currentSchedule = schedule;
  // }
  // public updateCurrentSchedule(): void {
  //   const humanstring = later.parse.text(
  //     translateToHumanReadableString(this.cronobject.toString())
  //   );
  //   this._currentSchedule = later.schedule(humanstring);
  // }
  // /**
  //  * @description A function which takes  as input the name of the field of QuartzObject which should be set with a specific value.
  //  * The function checks the rules specified by QuartzObject and sets the field accordingly.
  //  * @param field The field to update identified by RegexGroups
  //  * @param value The value to set the field to
  //  */
  // setField(
  //   field: RegexGroupsQuartzCron | RegexGroupsHumanReadable,
  //   value: number | number[] | string
  // ): void {
  //   // console.log("---------");
  //   // console.log("called setField", field, value);
  //   //Find the field in this.quartzobject.rules identified by field
  //   const ruleset = this.cronobject.rules.find(
  //     (entry) => entry.field === field
  //   );
  //   if (ruleset) {
  //     const fieldvalue = ruleset.modify(value, this);
  //     // console.log("returned value", field, fieldvalue);
  //     // console.log("---------");
  //     this.cronobject[ruleset.setter] = fieldvalue;
  //     ruleset.rules.forEach((rule) => {
  //       this.cronobject[rule.field] = rule.modify();
  //     });
  //   }
  // }
  // /**
  //  * Reset the current state to the initial state.
  //  */
  // resetState(): void {
  //   this.cronobject.reset();
  //   this._cronstringcopied = false;
  //   this._currentEnddate = undefined;
  //   this._monthlySwitcher = 1;
  //   this._selectedMonthInCalendar = dayjs().get("month");
  //   this._selectedYearInCalendar = dayjs().get("year");
  //   this._startdate = dayjs().second(0).minute(0).hour(8);
  // }
  // /**
  //  * @description Provides a string representation of the cron object.
  //  * @returns string
  //  */
  // objectToString(): string {
  //   this.cronobject.toString();
  //   this._cronstringcopied = false;
  //   return this.cronobject.toString();
  // }
  // /**
  //  * @description Checks whether the passed date fits the passed cron string.
  //  * @param date
  //  * @returns boolean
  //  */
  // checkDateAgainstCronString(cronstring: string, date: Dayjs): boolean {
  //   this.cronobject.parseCronString(cronstring);
  //   return this.fitsDate(date);
  // }
  // /**
  //  * @description Checks whether the passed date fits the current state (cron object).
  //  * @param value
  //  * @returns
  //  */
  // fitsDate(value: Dayjs): boolean {
  //   return this.currentSchedule.isValid(value.toDate());
  // }
  // /**
  //  * This function returns the next dates fitting the cron string.
  //  * @param amount The number of dates to return.
  //  * @returns An array of Dayjs objects fitting the cron string.
  //  */
  // nextDates(amount: number): Array<Dayjs> {
  //   const dates: Array<Date> | Date = this.currentSchedule.next(amount);
  //   if (Array.isArray(dates)) {
  //     return dates.map((date) => dayjs(date));
  //   } else if (dates instanceof Date) {
  //     return [dayjs(dates)];
  //   }
  //   return [];
  // }
}
